import { FC, useReducer, useLayoutEffect, ComponentProps } from "react";

import dayjs from "dayjs";

import { Select } from "@mantine/core";
import { useLanguageCode } from "@hooks/useLanguageCode";

import i18n from "../../i18n";

export const LanguageSelector: FC<
  Omit<ComponentProps<typeof Select>, "data">
> = (props) => {
  const [, forceRender] = useReducer(() => ({}), {});

  const currentLanguage = useLanguageCode();

  useLayoutEffect(() => {
    if (["en", "de"].includes(currentLanguage)) return;

    const toSet = /^de-/.test(currentLanguage) ? "de" : "en";

    i18n.changeLanguage(toSet);
    dayjs.locale(toSet);
  }, [currentLanguage]);

  useLayoutEffect(() => {
    dayjs.locale(currentLanguage);
  });

  return (
    <Select
      w={90}
      size="xs"
      placeholder="Language"
      value={currentLanguage}
      onChange={(ev) => {
        if (!ev) return;
        i18n.changeLanguage(ev);
        dayjs.locale(ev);
        forceRender();
      }}
      data={[
        { value: "de", label: "Deutsch" },
        { value: "en", label: "English" },
      ]}
      {...props}
    />
  );
};
